module.exports = __webpack_public_path__ + "img/about_tom.b4bb5d59.png";